import FlashPanel from 'shared-assets/components/FlashPanel';

angular
  .module('kareo.ui.shared.directives.k-flash-panel', [
    'react'
  ])
  .directive('kFlashPanel', dcFlashPanel);


dcFlashPanel.$inject = ['reactDirective'];
function dcFlashPanel(reactDirective) {
  var bindings = {
    displayType: '@',
    hasClose: '=',
    fadeOut: '=',
    fadeOutMs: '=',
    isOpen: '=',
    onClose: '=',
    autoPosition: '=',
  };

  return reactDirective(FlashPanel, bindings, props => {
    // we coerce a value for backwards compatability since react will use the default value if left undefined
    props.isOpen = !!props.isOpen;
    return props;
  });
}
